import {useRef, useEffect} from "react";
import {
  Box,
  Flex,
  Text,
  IconButton,
  Button,
  Stack,
  Collapse,
  Icon,
  Link,
  Popover,
  PopoverTrigger,
  PopoverContent,
  useColorModeValue,
	Image,
  useDisclosure,
	useToast,
} from '@chakra-ui/react';
import {
  HamburgerIcon,
  CloseIcon,
  ChevronDownIcon,
  ChevronRightIcon,
} from '@chakra-ui/icons';
import { useAuth } from "../../contexts/AuthContext";
import { connectWallet } from '../../services/walletConnections';
import { loginWithWallet } from '../../services/walletLogin';
import { formatAddress } from '../../utils/common';
import { HEADER_BACKGROUND_IMAGE, MAIN_COLOR } from "../../config";

import intl from "../../utils/intl";

const linkColor = "#ffff";
const linkHoverColor = "#ffff";
const popoverContentBgColor = "#08152ba0"

export default function Header() {
  const { isOpen, onToggle } = useDisclosure();
	const { 
		currentAccount,
    setCurrentAccount, 
		setJwToken,
    setCurrentNetwork
  } = useAuth();

	const toast = useToast();
  const id = 'toast';
	const initialized = useRef(false);

	useEffect(() => {
		// console.log("Initialization");
    const init = async() => {
			if(initialized.current) return;
			try {
        const chainId = await window.ethereum.request({ method: 'eth_chainId' });
        setCurrentNetwork(parseInt(chainId, 16))
        const accounts = await window.ethereum.request({ method: 'eth_accounts' });
        if (accounts.length > 0) {
					// console.log("===1===")
					await sign(chainId, accounts[0]);
        } else {
					await window.ethereum.request({ method: 'eth_requestAccounts'});
					const accounts = await window.ethereum.request({ method: 'eth_accounts' });
					await sign(chainId, accounts[0]);
				}

        window.ethereum.on('accountsChanged', async function (accounts) {
          const chainId = await window.ethereum.request({ method: 'eth_chainId' });
					// console.log("===2===")
					await sign(chainId, accounts[0]);
          //window.location.reload()
        })
        
        window.ethereum.on('chainChanged', async function (chainId) {
					// console.log("===3===")
					await sign(chainId, currentAccount);
          setCurrentNetwork(parseInt(chainId, 16));
          //window.location.reload()
        })
      } catch(err) {
        console.log(err)
      }
    }
		init();
		return () => initialized.current = true;
	}, []);
	// }, [setCurrentAccount, setCurrentNetwork, currentAccount, setJwToken]);

	const sign = async (chainId, account) => {
		const jwtToken = await loginWithWallet(parseInt(chainId, 16), account);
		setCurrentAccount(account);
		setJwToken(jwtToken);
	}
	
	const handleLogin = async() => {
		if(!window.ethereum) {
			if (!toast.isActive(id)) {
        toast({
          id,
          title: "Warn",
          description: 'Please install metamask',
          status: "error",
          duration: 4000,
          isClosable: true
			  })
      }
			return;
		}
		const account = await connectWallet();
		setCurrentAccount(account);
    const chainId = await window.ethereum.request({ method: 'eth_chainId' });
    setCurrentNetwork(parseInt(chainId, 16))
	}

  return (
    <Box
			backgroundImage={`url(${HEADER_BACKGROUND_IMAGE})`}
			minH={['400px', '880px']}
		>
      <Flex
        // bg={useColorModeValue('white', 'gray.800')}
        // color={useColorModeValue('gray.600', 'white')}
        // borderColor={useColorModeValue('gray.200', 'gray.900')}
				color={"white"}
        minH={'80px'}
				w={["100%", "70%"]}
				ml={["0", '15%']}
        py={{ base: 2 }}
        px={{ base: 4 }}
        // borderBottom={1}
        borderStyle={'solid'}
        align={'center'}>
        <Flex
          flex={{ base: 1, md: 'auto' }}
          ml={{ base: -2 }}
          display={{ base: 'flex', md: 'none' }}>
          <IconButton
            onClick={onToggle}
            icon={
              isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
            }
            variant={'ghost'}
            aria-label={'Toggle Navigation'}
          />
        </Flex>
        <Flex flex={{ base: 1 }} justify={{ base: 'center', md: 'start' }}>
				<Link to="/"><Image className="img-fluid" src="/assets/img/logo.png" alt="img" /></Link>

				{/* Menu for desktop */}
				<Flex display={{ base: 'none', md: 'flex' }} ml={10}>
            <DesktopNav />
				</Flex>
			</Flex>

        <Stack
          flex={{ base: 1, md: 0 }}
          justify={'flex-end'}
          direction={'row'}
          spacing={6}>
          <Button
            // display={{ base: 'none', md: 'inline-flex' }}
            fontSize={'sm'}
            fontWeight={600}
            color={'white'}
            bg={MAIN_COLOR}
            href={'#'}
            _hover={{
              bg: MAIN_COLOR,
            }}>
						{currentAccount === undefined ?
							<Box onClick={() => handleLogin()}>Connect Wallet</Box>:
							<Box>{formatAddress(currentAccount)}</Box>}
          </Button>
        </Stack>
      </Flex>

			{/* Menu for mobile */}
      <Collapse in={isOpen} animateOpacity>
        <MobileNav />
      </Collapse>
			<HeaderMiddle />
    </Box>
  );
}

const HeaderMiddle = () => {
	return(
		<Box color="white" mt={['20px', '200px']} textAlign="center" borderWidth="1px" width={['90%', '30%']} mx={'auto'} borderColor="white">
			<Box textAlign="center" borderWidth="1px" m="5px" borderColor="white">
				<Box textAlign="center" fontSize={['80px', '100px']} fontWeight={'800'}>
					NUSIC
				</Box>
				<Box bg={MAIN_COLOR} mx={"auto"} width={['70%', '70%']} height="2px"></Box>
				<Box fontSize={'20px'} my={'20px'}>
					<Box>FOR</Box>
					<Box>MUSICIANS</Box>
					<Box>AND CREATORS</Box>
				</Box>
			</Box>
		</Box>
	)
}

const DesktopNav = () => {
  // const linkColor = useColorModeValue('gray.600', 'gray.200');
  // const linkHoverColor = useColorModeValue('gray.800', 'white');
  // const popoverContentBgColor = useColorModeValue('white', 'gray.800');

  return (
    <Stack direction={'row'} spacing={4}>
      {NAV_ITEMS.map((navItem) => (
        <Box key={navItem.label}>
          <Popover trigger={'hover'} placement={'bottom-start'}>
            <PopoverTrigger>
              <Link
                p={2}
                href={navItem.href ?? '#'}
                fontSize={'md'}
                fontWeight={500}
                color={linkColor}
                _hover={{
                  textDecoration: 'none',
                  color: linkHoverColor,
                }}>
                {navItem.label}
              </Link>
            </PopoverTrigger>

            {navItem.children && (
              <PopoverContent
                border={0}
                boxShadow={'xl'}
                bg={popoverContentBgColor}
                p={4}
                rounded={'xl'}
                minW={'sm'}>
                <Stack>
                  {navItem.children.map((child) => (
                    <DesktopSubNav key={child.label} {...child} />
                  ))}
                </Stack>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      ))}
    </Stack>
  );
};

const DesktopSubNav = ({ label, href, subLabel }) => {
  return (
    <Link
      href={href}
      role={'group'}
      display={'block'}
      p={2}
      rounded={'md'}
      _hover={{ bg: useColorModeValue('#ffffffe0', 'gray.900') }}
			// _hove={{ bg: popoverContentBgColor}}
		>
      <Stack direction={'row'} align={'center'}>
        <Box>
          <Text
            // transition={'all .3s ease'}
            // _groupHover={{ color: 'MAIN_COLOR.400' }}
            fontWeight={500}>
            {label}
          </Text>
          <Text fontSize={'sm'}>{subLabel}</Text>
        </Box>
        <Flex
          transition={'all .3s ease'}
          transform={'translateX(-10px)'}
          opacity={0}
          _groupHover={{ opacity: '100%', transform: 'translateX(0)' }}
          justify={'flex-end'}
          align={'center'}
          flex={1}>
          <Icon 
						// color={'MAIN_COLOR.400'} 
						color={popoverContentBgColor}
						w={5} 
						h={5} 
						as={ChevronRightIcon} />
        </Flex>
      </Stack>
    </Link>
  );
};

const MobileNav = () => {
  return (
    <Stack
      bg={useColorModeValue('white', 'gray.800')}
      p={4}
      display={{ md: 'none' }}>
      {NAV_ITEMS.map((navItem) => (
        <MobileNavItem key={navItem.label} {...navItem} />
      ))}
    </Stack>
  );
};

const MobileNavItem = ({ label, children, href }) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Stack spacing={4} onClick={children && onToggle}>
      <Flex
        py={2}
        as={Link}
        href={href ?? '#'}
        justify={'space-between'}
        align={'center'}
        _hover={{
          textDecoration: 'none',
        }}>
        <Text
          fontWeight={600}
          color={useColorModeValue('gray.600', 'gray.200')}>
          {label}
        </Text>
        {children && (
          <Icon
            as={ChevronDownIcon}
            transition={'all .25s ease-in-out'}
            transform={isOpen ? 'rotate(180deg)' : ''}
            w={6}
            h={6}
          />
        )}
      </Flex>

      <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}>
        <Stack
          mt={2}
          pl={4}
          borderLeft={1}
          borderStyle={'solid'}
          borderColor={useColorModeValue('gray.200', 'gray.700')}
          align={'start'}>
          {children &&
            children.map((child) => (
              <Link key={child.label} py={2} href={child.href}>
                {child.label}
              </Link>
            ))}
        </Stack>
      </Collapse>
    </Stack>
  );
};

const NAV_ITEMS = [
  {
    label: intl.get("home"),
		href: '/',
  },{
		label: intl.get('explore'),
		children: [{
			label: intl.get("onsale"),
			subLabel: 'All onsale NFTs exclude mine',
			href: '/onsale',
		}, {
			label: intl.get("not_onsale"),
			subLabel: 'All NFTs not onsale exclude mine',
			href: '/unlisted',
		}, {
			label: intl.get("all"),
			subLabel: 'All NFTs including mine',
			href: '/all',
		}]
	}, 
	// {
  //   label: intl.get("liquidity"),
	// 	href: '/liquidity',
  // },
  {
    label: intl.get("create"),
    href: '/create',
  },{
		label: intl.get("my"),
		children: [{
			label: intl.get("onsale"),
			subLabel: 'My onsale NFTs',
			href: '/myonsale',
		}, {
			label: intl.get("not_onsale"),
			subLabel: 'My NFTs not onsale yet',
			href: '/myunlisted',
		}, {
			label: intl.get("claimpayment"),
			subLabel: 'Claim NFT saling profit',
			href: '/claimpayment'
		}]
	}, {
		label: intl.get("metafi"),
		subLabel: 'Meta Finance',
		href: 'https://nusic.app/h5/#/',
	}
];